__turbopack_context__.v({
  "button": "search-module-module__jKh0yG__button",
  "field": "search-module-module__jKh0yG__field",
  "panel": "search-module-module__jKh0yG__panel",
  "placeholder": "search-module-module__jKh0yG__placeholder",
  "submit": "search-module-module__jKh0yG__submit",
  "tab": "search-module-module__jKh0yG__tab",
  "wrapper": "search-module-module__jKh0yG__wrapper",
});
